// extracted by mini-css-extract-plugin
export default {"choices":"lsf-choices","choices_hidden":"lsf-choices_hidden","waiting":"lsf-waiting"};